import { DEFAULT_FILTERS, MasterFlagValue, ReturnWorkFilters } from './constants'

/**
 * 메뉴 세션(`moms_menu_on_session`)·URL 쿼리에 싣는 조회조건 모양(D16 — 공통 결정서 정정,
 * `@/hooks/useSessionPersistedState` 는 쓰지 않는다). 복원은 세션이 아니라 URL 에서 한다.
 * `erpInbound/searchQuery.ts` 와 같은 형태다.
 *
 * 이 화면은 목록 페이지네이션·검색어가 없어 `page`·`size`·`keyword` 에 대응하는 필드가 없다.
 *
 * | 필터 필드 | 컴포넌트 | 값 주입 통로 | 저장 |
 * | --- | --- | --- | --- |
 * | 마스터 조회여부 | `core.Select`(WorkTable) | `value`(완전 제어) | 한다 |
 * | d-ERP 전송여부 | 없음 — 셸에 토글이 없다(계획 8장 병행 추적) | 없음 | 값은 싣되, UI 가 생기기 전까지 항상 기본값(false)으로만 복원된다 |
 *
 * 마스터 조회여부는 `core.Select` 가 `value` prop 으로 완전 제어라 erpInbound 가 겪은
 * "통로 없는 필드" 문제가 없다 — 전부 저장·복원한다(D16).
 */
export interface ReturnWorkSearchQuery {
  masterFlag?: MasterFlagValue
  isSendToDoosonERP?: '1'
}

/** 화면 상태 → 저장 형태. 기본값과 같은 값은 키 자체를 빼 쿼리스트링을 짧게 유지한다. */
export const toSearchQuery = (filters: ReturnWorkFilters): ReturnWorkSearchQuery => ({
  ...(filters.masterFlag === DEFAULT_FILTERS.masterFlag ? {} : { masterFlag: filters.masterFlag }),
  ...(filters.isSendToDoosonERP ? { isSendToDoosonERP: '1' } : {}),
})

/** 문자열이 아닌 값(배열 등 조작된 URL)은 무시한다 — 화면이 깨지지 않게 한다. */
const text = (value: unknown) => (typeof value === 'string' && value ? value : undefined)

/** 저장된 쿼리를 화면 상태로 되돌린다. 알 수 없는 값은 기본값으로 되돌린다. */
export const fromSearchQuery = (query: Partial<ReturnWorkSearchQuery>): ReturnWorkFilters => ({
  masterFlag: text(query.masterFlag) === 'Y' ? 'Y' : DEFAULT_FILTERS.masterFlag,
  isSendToDoosonERP: query.isSendToDoosonERP === '1',
})
